import { defineStore } from "pinia";

export const useThemeStore = defineStore("theme", {
  state: () => ({
    primaryColor: "#00A8E8",
    kioskMode: localStorage.getItem("kioskMode") || false,
  }),
  actions: {
    updatePrimaryColor(newColor) {
      // update store
      this.primaryColor = newColor;
    },
    setKioskMode(kioskMode) {
      this.kioskMode = kioskMode;
      if (kioskMode) {
        localStorage.setItem("kioskMode", true);
      }
      else {
        localStorage.removeItem("kioskMode");
      }
    },
    updateKioskMode(kioskMode) {
      if (typeof kioskMode === "boolean") {
        this.setKioskMode(kioskMode);
        return;
      }

      const url = new URL(document.URL);
      if (url.searchParams.has("nokiosk")) {
        this.disableKioskMode();
      }
      else if (url.searchParams.has("kiosk")) {
        this.enableKioskMode();
      }
      else {
        this.setKioskMode(localStorage.getItem("kioskMode") !== null);
      }
    },
    disableKioskMode() {
      this.setKioskMode(false);
    },
    enableKioskMode() {
      this.setKioskMode(true);
    },
  },
});
